import { AppReview } from '@capawesome/capacitor-app-review';
import { Preferences } from '@capacitor/preferences';
import {
    APP_REVIEW_REQUEST_TIME_PERIOD,
    APP_REVIEW_REQUEST_TIMESTAMP_KEY,
} from '../constants/constants';
import { isNativePlatform } from './platformUtil';

export const requestInAppReview = async ({
    force = false,
}: {
    force?: boolean;
} = {}) => {
    try {
        if (!isNativePlatform()) return;
        // const { value: lastRequestedAt } = await Preferences.get({
        //     key: APP_REVIEW_REQUEST_TIMESTAMP_KEY,
        // });

        const now = Date.now();

        // if (
        //     !force &&
        //     lastRequestedAt &&
        //     now - Number(lastRequestedAt) < APP_REVIEW_REQUEST_TIME_PERIOD
        // ) {
        //     return;
        // }

        await AppReview.requestReview();

        await Preferences.set({
            key: APP_REVIEW_REQUEST_TIMESTAMP_KEY,
            value: String(now),
        });
    } catch (error) {
        console.warn('In-app review failed:', error);
    }
};
